// src/main.tsx
import React from "react";
import ReactDOM from "react-dom/client";
import { registerSW } from "virtual:pwa-register";
import App from "./ui/App";
import { colors } from "./ui/design-system/colors";

// 9章: Service Worker更新時は強制リロードせず、ユーザーに更新を促すバナーを出す
const updateSW = registerSW({
  onNeedRefresh() {
    const shouldUpdate = window.confirm(
      "新しいバージョンのKinemaLens AIが利用可能です。今すぐ更新しますか?",
    );
    if (shouldUpdate) updateSW(true);
  },
  onOfflineReady() {
    console.info("[KinemaLens] オフラインで動作する準備ができました");
  },
});

document.body.style.backgroundColor = colors.bg;
document.body.style.color = colors.textPrimary;
document.body.style.margin = "0";

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("root element not found");

ReactDOM.createRoot(rootEl).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
